<div
	class="analytics-root"
	[class.analytics-root--capture]="captureMode"
	[attr.data-report-capture-ready]="captureReady() ? 'true' : null"
>
	@if (accessState() === 'allowed') {
		<jepto-view-container
			#view
			[viewConfig]="viewConfig()"
			[viewOnly]="true"
			[captureMode]="captureMode"
			[pageLoading]="pageLoading()"
			[selectedPage]="selectedPageForView()"
			[reportDateRangeExpression]="reportDateRangeExpressionForView()"
			(filterDateRangeChange)="onFilterDateRangeChange($event)"
		></jepto-view-container>

		@if (!captureMode) {
			<button
				type="button"
				class="analytics-pdf-export-fab"
				[disabled]="pdfExportInProgress()"
				[attr.aria-busy]="pdfExportInProgress()"
				aria-label="Download PDF"
				(click)="onDownloadPdfClick()"
			>
				@if (pdfExportInProgress()) {
					<span
						class="analytics-pdf-export-fab__spinner"
						aria-hidden="true"
					></span>
				} @else {
					<mat-icon class="material-symbols-outlined" aria-hidden="true"
						>download</mat-icon
					>
				}
			</button>
		}
	} @else if (accessState() === 'checking') {
		<div
			class="analytics-access-checking"
			role="status"
			aria-live="polite"
			aria-label="Loading report access"
		>
			<span
				class="analytics-access-checking__spinner"
				aria-hidden="true"
			></span>
		</div>
	} @else if (accessState() === 'gate' || accessState() === 'denied') {
		<analytics-report-access-gate
			[reportId]="reportId() ?? ''"
			[initialStep]="accessState() === 'denied' ? 'denied' : 'email'"
			[brandName]="gateBrandName()"
			[brandLogoUrl]="gateBrandLogoUrl()"
			(verified)="onAccessVerified()"
		></analytics-report-access-gate>
	}
</div>
